/** Type guard shared by the P2P handover parsers (untrusted JSON). */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}
